const routeMap: Record<string, { en: string; ar: string }> = {
  home:        { en: '/',                    ar: '/ar/' },
  about:       { en: '/about-us',            ar: '/ar/من-نحن' },
  companies:   { en: '/our-companies',       ar: '/ar/شركاتنا' },
  projects:    { en: '/projects',            ar: '/ar/مشاريعنا' },
  investors:   { en: '/investors-relation',  ar: '/ar/علاقات-المستثمرين' },
  media:       { en: '/media-center',        ar: '/ar/المركز-الإعلامي' },
  contact:     { en: '/contact-us',          ar: '/ar/اتصل-بنا' },
  privacy:     { en: '/privacy',             ar: '/ar/privacy' },
  terms:       { en: '/terms',               ar: '/ar/terms' },
  suppliers:   { en: '/suppliers-registration', ar: '/ar/تسجيل-الموردين' },
  careers:     { en: '/careers/apply',       ar: '/ar/التوظيف/تقديم' },
};

export function getLocalizedPath(pageKey: string, lang: string): string {
  const entry = routeMap[pageKey];
  if (!entry) return '/';
  return lang === 'ar' ? entry.ar : entry.en;
}

export function detectLanguageFromPath(pathname: string): 'ar' | 'en' {
  return pathname.startsWith('/ar') ? 'ar' : 'en';
}

export function getEquivalentPath(currentPath: string, targetLang: string): string {
  const decoded = decodeURIComponent(currentPath);

  for (const key of Object.keys(routeMap)) {
    const entry = routeMap[key];

    if (decoded === entry.en || decoded === entry.ar) {
      return targetLang === 'ar' ? entry.ar : entry.en;
    }

    const enBase = entry.en;
    const arBase = entry.ar;
    if (decoded.startsWith(enBase + '/')) {
      const slug = decoded.slice(enBase.length);
      return targetLang === 'ar' ? arBase + slug : decoded;
    }
    if (decoded.startsWith(arBase + '/')) {
      const slug = decoded.slice(arBase.length);
      return targetLang === 'ar' ? decoded : enBase + slug;
    }
  }

  if (targetLang === 'ar' && !decoded.startsWith('/ar')) {
    return '/ar' + decoded;
  }
  if (targetLang === 'en' && decoded.startsWith('/ar/')) {
    return decoded.slice(3) || '/';
  }
  if (targetLang === 'en' && decoded === '/ar') {
    return '/';
  }

  return decoded;
}

export { routeMap };
